import { Component, Input } from '@angular/core';

@Component({
    selector: 'ig-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
    @Input() public diameter = 32;
    @Input() public strokeWidth = 3;

    constructor() {
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/spinner/spinner.component.ts